const isLocalhost = (global = window) => {
  return Boolean(global?.location?.hostname === 'localhost')
}

export { isLocalhost }
